module.exports = __webpack_public_path__ + "static/img/multiPositionControllerImg.1dd0f40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/multiPositionControllerImg.png
// module id = 1rps
// module chunks = 1